import request from '../utils/http'
const appid = 6001  // 不同小程序对接同一后台  5-维应生活服务开发版、2005-维应生活服务、6001-比鹏鸟

// 用户注册
export function register(data) {
    return request({
        url: "/service/h5.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "reg",
            appid,
            ...data
        }  //接口参数
    })
}

// 管理员登录
export function login(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "login_admin",
            ...data
        }  //接口参数
    })
}

// 获取token park0
export function getToken() {
    return request({
        url: "/service/park.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "gettoken",
            appkey: 'park2023',
            appsecret: 'SefByUjaOTdgwFFUjzSOvwEsZLKvfmoI'
        }  //接口参数
    })
}

// 管理员登录获取开发id 273
export function adminGuid(data) {
    return request({
        url: "/service/user.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "getopenid",
            ...data
        }  //接口参数
    })
}

// 企业用户登录
export function userLogin(data) {
    return request({
        url: "/service/h5.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'login',
            appid,
            ...data
        }  //接口参数
    })
}

// 获取用户信息 198
export function getUserInfo(data) {
    return request({
        url: "/service/shop.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'getuser',
            ...data
        }  //接口参数
    })
}


// 发送手机号 280
export function sendVerfity(data) {
    return request({
        url: "/service/shop.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'sms',
            ...data
        }  //接口参数
    })
}

// 手机号验证 281
export function verifyPhoto(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'login_mobile',
            appid,
            ...data
        }  //接口参数
    })
}

// 忘记登录密码（重置） 282
export function resetPass(data) {
    return request({
        url: "/service/spr.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'login_mobile_uppwd',
            appid,
            ...data
        }  //接口参数
    })
}

// 修改登录密码 279
export function updatePass(data) {
    return request({
        url: "/service/user.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: 'updatepwd',
            appid,
            ...data
        }  //接口参数
    })
}


// 图片上传 228
export function uploadImage(data) {
    return request({
        url: "/service_app/ImageUpload.ashx",  //接口路径
        method: "post",  //接口方法
        headers: { 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryBjuIjXHahe4oN0BB;' }, //给接口添加请求头
        data  //接口参数
    })
}

// park1 服务片区点位列表
export function getOrderParameter(data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'order_parameter',
            ...data
        }
    })
}

// 获取省市 57
export function getProvince() {
    return request({
        url: '/service/shop.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'area'
        }
    })
}

// 获取城市 58
export function getCity(id) {
    return request({
        url: '/service/shop.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'city',
            areaid: id
        }
    })
}

// 获取区域 286
export function getArea(id) {
    return request({
        url: '/service/shop.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'addr',
            cityid: id
        }
    })
}

// 查看订单取餐信息 park9
export function getTakeMealInfo(data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'pickupview',
            ...data
        }
    })
}

// park13  取餐员扫码 - 确认取餐
export function getTakeMeal(data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'pickupadd',
            ...data
        }
    })
}

// 送餐员送餐 park10
export function getSendMeal(data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'deliveryadd',
            ...data
        }
    })
}

// 分配员送餐 park12
export function getDispatch (data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'serinfoadd',
            ...data
        }
    })
}

// 分配员送餐 park12
export function addDispatch (data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'serinfoedit',
            ...data
        }
    })
}

// 分派员扫码-放入大柜
export function putBigCabinet (data) {
    return request({
        url: '/service/cabinet/action.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'getbig',
            ...data
        }
    })
}
// 分派员扫码-放入小柜
export function putSmallCabinet (data) {
    return request({
        url: '/service/cabinet/action.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'getsmall',
            ...data
        }
    })
}

// park18 查询开柜是否成功
export function checkbonxcn (data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'checkboxcn',
            ...data
        }
    })
}

// 获取订单信息 park15
export function getOrderInfo(data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'orderview',
            ...data
        }
    })
}

// park6 分页获取外卖订单
export function getOrderList(data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'park_order_list',
            ...data
        }
    })
}

// park21 分页获取投诉
export function getScoldList(data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'scold_list',
            ...data
        }
    })
}

// 查询开箱状态
export function getBoxState(data) {
    return request({
        url: '/service/cabinet/action.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'getboxstate',
            ...data
        }
    })
}

// 修改订单投诉审核状态 park23
export function scoldCheck(data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'scold_check',
            ...data
        }
    })
}

// 订单分配管理员 park27
export function orderSendManage(data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'park_orderadd_sendmanage',
            ...data
        }
    })
}

// park28 分派员批量操作（直接配送）
export function serinfoaddGroup(data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'serinfoadd_group',
            ...data
        }
    })
}

// park29 判断订单是否需要出现重置按钮
export function isShoeReset(data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'isshowreset',
            ...data
        }
    })
}

// park30 重置订单状态到已接单
export function resetOrder (data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'resetlog',
            ...data
        }
    })
}

// flash2 分页获取跑腿订单
export function getParkOrderList (data) {
    return request({
        url: '/service/park_flash.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'park_flash_order_list',
            ...data
        }
    })
}

// flash3 跑腿订单详情
export function getParkOrderDetail (data) {
    return request({
        url: '/service/park_flash.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'park_flash_order_view',
            ...data
        }
    })
}

// flash5 把订单指派给跑腿员
export function getParkDelivery (data) {
    return request({
        url: '/service/park_flash.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'park_order_delivery',
            ...data
        }
    })
}

// flash6 跑腿服务派单（指派管理员）
export function getParkOrderGet (data) {
    return request({
        url: '/service/park_flash.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'park_order_get',
            ...data
        }
    })
}

// flash7 跑腿服务重新派单
export function getParkOrderDel (data) {
    return request({
        url: '/service/park_flash.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'del_get',
            ...data
        }
    })
}

// flash8 管理员列表
export function getAdminUserList (data) {
    return request({
        url: '/service/park_flash.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'order_areapage',
            ...data
        }
    })
}

// flash9 上报订单异常
export function submitAbnormal (data) {
    return request({
        url: '/service/park_flash.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'abnormal',
            ...data
        }
    })
}

// flash10 取消订单
export function cancelAbnormal (data) {
    return request({
        url: '/service/park_flash.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'cancel',
            ...data
        }
    })
}

// flash12 投诉 - 客服提交投诉处理办法给用户
export function submitComplaint (data) {
    return request({
        url: '/service/park_flash.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'flash_complaint_reply',
            ...data
        }
    })
}

// flash12 跑腿员-取件
export function getPickUp (data) {
    return request({
        url: '/service/park_flash.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'pickup_the_item',
            ...data
        }
    })
}

// flash13 跑腿员-开始送件
export function getDelivery (data) {
    return request({
        url: '/service/park_flash.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'run_item',
            ...data
        }
    })
}

// flash14 跑腿员-确认送达
export function getDeliverySuccess (data) {
    return request({
        url: '/service/park_flash.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'success_item',
            ...data
        }
    })
}

// flash17 分页获取投诉记录
export function getComplaintList (data) {
    return request({
        url: '/service/park_flash.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'park_flash_complaint_list',
            ...data
        }
    })
}

// park32 查询某一天订单的餐厅列表
export function getShopList (data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'shoplist',
            ...data
        }
    })
}

// park33 查询餐厅下的楼栋列表
export function getShopLouList (data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'loulist',
            ...data
        }
    })
}

// park34 查询楼栋下的订单列表
export function getShopLouDetail(data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'louorderlist',
            ...data
        }
    })
}

// 加密参数 423
export function encryptstringadd(data) {
    return request({
        url: '/service/encryptstring.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'encryptstringadd',
            ...data
        }
    })
}

// 解密参数 424
export function encryptstringview(data) {
    return request({
        url: '/service/encryptstring.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'encryptstringview',
            ...data
        }
    })
}

// park35 按照服务片区汇总订单
export function getParameterOrderList(data) {
    return request({
        url: '/service/park.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'order_parameter_order',
            ...data
        }
    })
}

// park37 订单商品明细-详情
export function getOrderDetail(data) {
    return request({
        url: '/service/bipengbird/pickup.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'pickup_detaillist',
            ...data
        }
    })
}

// park37 订单商品明细-取餐
export function getOrderTakeMeal(data) {
    return request({
        url: '/service/bipengbird/pickup.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'pickup_detailedit',
            ...data
        }
    })
}

// flash6 跑腿服务派单（指派管理员）
export function getParkOrderDispatch (data) {
    return request({
        url: '/service/park_flash.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'park_order_get',
            ...data
        }
    })
}
